import React from 'react';

const ProgressBar = () => {
  return (
    <div className="progress-bar dot-loader">
      <i className="dot dot--first"></i>
      <i className="dot dot--second"></i>
      <i className="dot dot--third"></i>
      <i className="dot dot--fourth"></i>
    </div>
  );
};

export default ProgressBar;
